import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Styles from "../styles/";
import { Grid } from "@material-ui/core";
import {
  Input,
  InputDate,
  InputTags,
} from "../../../components/inputs/newForm";

const filtersSchema = z.object({
  type: z.any().optional(),
  name: z.string().optional(),
  placeNames: z.any().optional(),
  solicitationDate: z.date().nullable().optional(),
  startDate: z.date().nullable().optional(),
  endDate: z.date().nullable().optional(),
  vehiclePlate: z.string().optional(),
  status: z.any().optional(),
});

type FiltersFormData = z.infer<typeof filtersSchema>;

function Filters({
  onSubmit,
  loading,
  placeList,
  statusList,
  profileList,
}: any) {
  const { control, handleSubmit, reset, setValue, getValues } =
    useForm<FiltersFormData>({
      resolver: zodResolver(filtersSchema),
      defaultValues: {
        type: [],
        name: "",
        placeNames: [],
        solicitationDate: null,
        startDate: null,
        endDate: null,
        vehiclePlate: "",
        status: [],
      },
    });

  return (<form style={{ display: 'flex', width: '100%', flexDirection: 'column' }} onSubmit={handleSubmit((data) => onSubmit(data))}>


    <Grid alignItems="flex-end" container spacing={1}>
      <Styles.CustomGrid container item xs={12} md={6} lg={1}>
        <InputTags
          control={control}
          name="type"
          label="Perfil"
          options={profileList ?? []}
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid item xs={12} md={6} lg={1}>
        <Input
          control={control}
          name="name"
          label="Nome"
          placeholder="Nome"
          disabledError
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid container item xs={12} md={6} lg={1}>
        <InputTags
          control={control}
          name="placeNames"
          label="Imóvel"
          options={placeList ?? []}
          multiple={true}
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid container item xs={12} md={6} lg={1}>
        <InputDate disabledError
          control={control}
          name="solicitationDate"
          label="Solicitação"
          onDateChange={(value) => {
            const start = getValues("startDate");
            if (start && value && start < value) {
              setValue("startDate", null);
            }
          }}
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid item xs={12} md={4} lg={1}>
        <InputDate disabledError
          control={control}
          name="startDate"
          label="Check-In"
          onDateChange={(value) => {
            const end = getValues("endDate");
            if (end && value && end < value) {
              setValue("endDate", null);
            }
          }}
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid item xs={12} md={4} lg={1}>
        <InputDate disabledError
          control={control}
          name="endDate"
          label="Check-Out"
          onDateChange={(value) => {
            const start = getValues("startDate");
            if (start && value && start > value) {
              setValue("startDate", null);
            }
          }}
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid item xs={12} md={3} lg={1}>
        <Input disabledError
          control={control}
          name="vehiclePlate"
          label="Placa do Veículo"
          placeholder="Placa do Veículo"
        />
      </Styles.CustomGrid>
      <Styles.CustomGrid item xs={12} md={4} lg={1}>
        <InputTags
          control={control}
          name="status"
          label="Status"
          options={statusList ?? []}
        />
      </Styles.CustomGrid>
    </Grid>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      <Styles.ButtonContainer>
        <Styles.Clear
          loading={loading}
          disabled={loading}
          fullWidth={false}
          onClick={() => reset()}
        >
          Limpar
        </Styles.Clear>
      </Styles.ButtonContainer>
      <Styles.ButtonContainer>
        <Styles.Submit
          loading={loading}
          disabled={loading}
          fullWidth={false}
          onClick={handleSubmit((data) => onSubmit(data))}
        >
          Aplicar Filtros
        </Styles.Submit>
      </Styles.ButtonContainer>
    </div>

  </form>
  );
}

export default Filters;
